import React from "react";
import { Button } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import FileUpload from "../../../../components/FileUpload";

function FileUploadButton({ fullWidth = false }) {
  return (
    <FileUpload>
      <Button
        fullWidth={fullWidth}
        variant="contained"
        color="primary"
        startIcon={<UploadFile />}
        sx={{ minWidth: 145 }}>
        Upload File
      </Button>
    </FileUpload>
  );
}

export default FileUploadButton;
